export default __webpack_public_path__ + "static/media/quiz.dcbc1404.webp";